var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[(_vm.headerVisible)?_c('Header',{staticClass:"header"}):_vm._e(),_c('div',{staticClass:"main"},[_c('router-view')],1),(_vm.headerVisible)?_c('Footer',{staticClass:"footer"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }